module.exports = __webpack_public_path__ + "img/close.5f603067.svg";